"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.ConsumesPanelContext = exports.Provider = exports.Consumer = exports.defaultValues = exports.types = void 0;

var _react = require("react");

var _consumerDecoratorFactory = _interopRequireDefault(require("./consumerDecoratorFactory"));

var types = {
  inPanel: _react.PropTypes.bool.isRequired
};
exports.types = types;
var defaultValues = {
  inPanel: false
};
exports.defaultValues = defaultValues;

var _createContext = (0, _react.createContext)(defaultValues),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;
var ConsumesPanelContext = (0, _consumerDecoratorFactory.default)('panel', Consumer);
exports.ConsumesPanelContext = ConsumesPanelContext;

var propType = _react.PropTypes.shape(types);

exports.propType = propType;